<template>
  <div 
    v-if="visivel"
    id="Mix" @click="fechar()" 
    style="display: block; padding-top: 50px" 
    class="w3-modal" 
    v-cloak>
    
    <div class="w3-modal-content" style="width: 82%;" @click.stop v-cloak>
      <header v-cloak>
        <span @click="fechar()" class="w3-button w3-display-topright">&times;</span>
        <h4 class="texto-vermelho titulo">Mix do Pedido</h4>
      </header>

      <div class="w3-col">
        <div class="w3-col s6 l6 m6 w3-left">
          <label data-strong="resultado-venda" class="texto-vermelho">Pedido</label>
          <strong data-strong="resultado-venda" class="texto-vermelho">{{mix.orcamento_id}}</strong>
            <legenda>
              <span v-if="autorizado_visualizar_lucratividade_mix">mix: {{mix.perc_lucro_liquido.replace(' ','')}}</span>
              <span v-if="!autorizado_visualizar_lucratividade_mix">Informações mix</span>
              <i slot="referencia" class="fa fa-circle resultado-venda bolinha w3-border " :style="getEstiloCor(mix.cor)"></i> 
            </legenda>
            <strong 
              class="texto-verde" style="white-space:nowrap;" 
              data-strong="resultado-venda">&nbsp;
              R$ {{mix.total_geral}}
            </strong>
        </div>

        <div class="w3-col s6 l6 m6 w3-right texto-vermelho">
          <label class="w3-right" data-label="resultado-venda">{{mix.data_fechamento}}</label>
        </div>
            
        <div class="w3-col l6 m12">
          <legenda>
            <span>Nome Do cliente</span>
              <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
          </legenda>
          <strong data-label="resultado-venda" id="eResultado">{{mix.nome_cliente}}</strong>
        </div>

        <div class="w3-col l6 m12">
          <legenda>
            <span>Nome do vendedor</span>
            <i slot="referencia" class="fa fa-user-tie texto-vermelho"></i>
          </legenda>
          <label data-label="resultado-venda" id="eResultado">&nbsp;{{mix.nome_vendedor}}</label>
        </div>

        <div data-div="condicao-pagamento" class="w3-col s12 m12 l6">
          <legenda>
            <div>Condição de  pagamento</div>
            <i slot="referencia" class="fas fa-credit-card texto-vermelho"></i>
          </legenda>
          <label>&nbsp;{{mix.nome_condicao}}</label>
        </div>
            
        <div class="w3-col l6 m12">
          <legenda>
            <span>Tipo entrega</span>
            <i slot="referencia" class="fas fa-shipping-fast texto-vermelho"></i>
          </legenda>
          <label data-label="resultado-venda" id="eResultado">{{mix.tipo_entrega}}</label>
        </div>

        <div class="w3-col l6 m6" v-if="mix.nome_resumido_empresa">
          <legenda>
            <span>Nome da empresa</span>
            <i slot="referencia" class="fas fa-building  texto-vermelho"></i>
          </legenda>
          <label data-label="resultado-venda" id="eResultado">&nbsp;{{mix.nome_resumido_empresa}}</label>
        </div>
      </div> 
      <div 
        v-if="autorizado_visualizar_lucratividade_mix || autorizado_visualizar_lucro_liquido_mix"
        class="w3-half w3-mobile">

        <h6 
          @click="mostrarLucro()" 
          v-if="!mostrar_lucro" class="fundo-cabecalho ">&nbsp;
            <i class="fas fa-caret-right"></i>&nbsp;
            <a href="#">Apuração do lucro</a>&nbsp;
            <span v-if="mix.valor_lucro_bruto">R$ {{mix.valor_lucro_bruto}}</span>
        </h6>

        <h6 
          @click="mostrarLucro()" 
          v-if="mostrar_lucro" class="fundo-cabecalho">&nbsp;
          <i class="fas fa-sort-down"></i>&nbsp;
          <a href="#">Apuração do lucro</a>&nbsp;
          <strong v-if="mix.valor_lucro_bruto">R$ {{mix.valor_lucro_bruto}}</strong>
        </h6>
        <div v-if="mostrar_lucro" class="w3-animate-zoom">

          <div 
            class="w3-row" 
            v-if="mix.perc_lucro_bruto && 
            autorizado_visualizar_lucratividade_mix">
            
            <label>Lucro bruto: </label>
            <strong 
              :class="getCorLucro(mix.perc_lucro_bruto)" 
              data-label="valor-lucro-bruto" 
              id="eLucroBruto">
              ({{mix.perc_lucro_bruto.replace(' %','%)')}}
            </strong>
          </div>

          <div
            v-if="autorizado_visualizar_lucratividade_mix &&
            mix.base_lucro_presente" 
            class="w3-row">
            
            <label>Base lucro presente: </label>
            <strong data-label="base-lucro-presente" id="eBaseLucroPresente">
              R$ {{mix.base_lucro_presente}}
            </strong>
          </div>
                
          <div v-if="autorizado_visualizar_lucratividade_mix" class="w3-row">
            <label>Acréscimo do custo da compra: </label>
            <strong
              v-if="mix.perc_acrescimo" 
              data-label="percentual-acrescimo"
              id="ePercAcresCustoCompra">
              
              ({{mix.perc_acrescimo.replace(' %','%)')}}
            </strong>
          </div>

          <h6 
            class="w3-row w3-animate-zoom fundo-cabecalho" 
            v-show="autorizado_visualizar_lucratividade_mix" >&nbsp;
            Apuração do lucro sem promoção/ponta
          </h6>

          <div v-show="autorizado_visualizar_lucratividade_mix"  class="w3-row w3-animate-zoom">
            <label>Base lucro presente: </label>
            <strong data-label="base-lucro-presente-sem-promocao" id="eBaseLucroPresenteSemProm">
              R$ {{mix.base_lucro_prod_sem_promocao}}
            </strong>
          </div>

          <div 
            v-if="autorizado_visualizar_lucratividade_mix || 
            autorizado_visualizar_lucro_liquido_mix"
            class="w3-row w3-animate-zoom">
            
            <label v-if="mix.perc_lucro_liquido" >Lucro líquido:</label>
            <strong  v-if="mix.perc_lucro_liquido" data-label="valor-lucro-liquido-sem-promocao" id="eLucroLiquidoSemProm">
              R$ {{mix.valor_lucro_liquido}} ({{mix.perc_lucro_liquido.replace(' %','%)')}}
            </strong>
          </div>
        </div>

        <h6 @click="mostrarLucro()" v-if="mostrar_lucro" class="w3-animate-zoom texto-vermelho">&nbsp;
          <i class="fas fa-arrow-circle-up w3-animate-zoom seta-mais-itens"></i>
        </h6>
        
      </div>
        
      <div class="w3-half w3-mobile" v-if="autorizado_visualizar_lucratividade_mix">
        <h6 @click="mostrarCustos()" v-if="!mostrar_custos" class="fundo-cabecalho ">&nbsp;
          <i class="fas fa-caret-right"></i>&nbsp;
          <a href="#">Custo final</a> &nbsp;
          <span v-if="mix.custo_final">R$ {{mix.custo_final}}</span>&nbsp;&nbsp;&nbsp;
        </h6>

        <h6 @click="mostrarCustos()" v-if="mostrar_custos" class="fundo-cabecalho">&nbsp;
          <i class="fas fa-sort-down"></i>&nbsp;
          <a href="#">Custo final</a> &nbsp;
          <span v-if="mix.custo_final">R$ {{mix.custo_final}}</span>&nbsp;&nbsp;&nbsp;
        </h6>

        <div v-if="mostrar_custos" class="w3-animate-zoom">
        
          <div v-show="autorizado_visualizar_lucratividade_mix" class="w3-row">
            <label>Compra: </label>
            <strong data-label="custo-compra" id="eCustoCompra" >
              R$ {{mix.custo_compra}}
            </strong>
          </div>

          <div v-show="autorizado_visualizar_lucratividade_mix" class="w3-row">
            <label>Impostos/outros: </label>
            <strong data-label="total-imposto" id="eImpostosOutros">
              R$ {{mix.total_imposto}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.frete_cif_embutido) > 0">
            <label>Frete CIF embutido: </label>
            <strong data-label="frete-cif-embutido" id="eFreteCifEmbutido">
              R$ {{mix.frete_cif_embutido}}
            </strong>
          </div>

          <div
            v-show="autorizado_visualizar_lucratividade_mix" 
            v-if="parseFloat(mix.juros_embutidos) > 0" 
            class="w3-row w3-animate-zoom">
            
            <label>Juros embutidos: </label>
            <strong data-label="juros-embutidos" id="eJurosEmbutidos">
              R$ {{mix.juros_embutidos}}
            </strong>
          </div>
          
          <div
            v-show="autorizado_visualizar_lucratividade_mix" 
            v-if="parseFloat(mix.total_encargos) > 0" 
            class="w3-row w3-animate-zoom">
            <label>Encargos: </label>
            <strong data-label="total-encargos" id="eEncargos">
              R$ {{mix.total_encargos}}
            </strong>
          </div>

          <div 
            class="w3-row w3-animate-zoom"
            v-if="parseFloat(mix.custo_frete_nao_cobrado) > 0 &&
            autorizado_visualizar_lucratividade_mix">
            
            <label>Custo frete não cobrado: </label>
            <strong data-label="custo-frete-nao-cobrado" id="eCustoFreteNaoCobrado">
              R$ {{mix.custo_frete_nao_cobrado}}
            </strong>
          </div>

          <div class="w3-row w3-animate-zoom" v-if="parseFloat(mix.comissao_profissional) > 0">
            <label>Comissão profissional: </label>
            <strong data-label="comissao-profissional" id="eComissaoProfissional">
              R$ {{mix.comissao_profissional}}
            </strong>
          </div>

          <div class="w3-row w3-animate-zoom" v-if="parseFloat(mix.custo_difal) > 0 ">
            <label>Custo DIFAL: </label>
            <strong data-label="custo-difal" id="eCustoDifal">
              R$ {{mix.custo_difal}}
            </strong>
          </div>

          <div class="w3-row w3-animate-zoom" v-if="parseFloat(mix.custo_protege) > 0">
            <label>Custo PROTEGE: </label>
            <strong data-label="custo-protege" id="eCustoProtege">
              R$ {{mix.custo_protege}}
            </strong>
          </div>

          <div class="w3-row w3-animate-zoom" v-if="parseFloat(mix.custo_estorno_protege) > 0 ">
            <label>Custo estorno PROTEGE: </label>
            <strong data-label="custo-estorno-protege" id="eCustoEstProtege">
              R$ {{mix.custo_estorno_protege}}
            </strong>
          </div>
        </div>

        <h6 
          @click="mostrarCustos()" 
          v-if="mostrar_custos" 
          class="texto-vermelho w3-animate-zoom">&nbsp;
          <i class="fas fa-arrow-circle-up w3-animate-zoom seta-mais-itens"></i>
        </h6>
      </div>
        
      <div class="w3-half w3-mobile">
        <h6 @click="mostrarTotais()" 
        v-if="!mostrar_totais" 
        class="fundo-cabecalho">&nbsp;
          <i class="fas fa-caret-right"></i>&nbsp;
          <a href="#">Totais</a>&nbsp;
          R$ {{mix.total_geral}}
        </h6>

        <h6 @click="mostrarTotais()" 
        v-if="mostrar_totais" 
        class="fundo-cabecalho">&nbsp;
          <i class="fas fa-sort-down"></i>&nbsp;
          <a href="#">Totais</a>&nbsp;R$ {{mix.total_geral}}
        </h6>

        <div v-if="mostrar_totais" class="w3-animate-zoom">
      
          <div class="w3-row">
            <label>Total bruto: </label>
            <strong data-label="total-bruto" id="eTotalBruto">
              R$ {{mix.total_bruto}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.total_valor_desconto_f5) > 0">
            <label>Desconto F5: </label>
            <strong data-label="valor-desconto-f5" id="eDescontoF5">
              R$ {{mix.total_valor_desconto_f5}}  ({{mix.perc_desconto_f5.trim(' ','')}}%)
            </strong>
          </div>
    
          <div class="w3-row">
            <label>Total sem promoção: </label>
            <strong data-label="total-sem-promocao" id="eTotalSemPromocao">
              R$ {{mix.total_sem_promocao}}
            </strong>
          </div>

          <div class="w3-row">
            <label>Total com over price: </label>
            <strong data-label="total-over-price" id="eTotalOverPrice">
              R$ {{mix.total_over_proce.replace(' ','')}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.valor_desconto) > 0">
            <label>Desc. fechamento:</label>
            <strong data-label="valor-desconto-fechamento" id="eDescFechamento">
              R$ {{mix.valor_desconto}} ({{mix.perc_desconto.trim(' ','')}}%)
            </strong>
          </div>
                  
          <div class="w3-row" v-if="parseFloat(mix.valor_desconto_geral) > 0">
            <label>Desconto geral: </label>
            <strong data-label="valor-desconto-geral" id="eDescontoGeral">
              R$ {{mix.valor_desconto_geral}} ({{mix.perc_desconto_geral.trim(' ','')}}%)
            </strong>
          </div>
                
          <div class="w3-row">
            <label>Total líquido: </label>
            <strong data-label="total-liquido" id="eTotalLiquido">
              R$ {{mix.total_liquido}}
            </strong>
          </div>
                  
          <div class="w3-row" v-if="parseFloat(mix.total_bruto_f5) > 0">
            <label>Total com F5: </label>
            <strong data-label="total-bruto-f5" id="eTotalF5">
              R$ {{mix.total_bruto_f5}}
            </strong>
          </div>

          <div class="w3-row" v-if=" parseFloat(mix.valor_desconto_pis_cofins) > 0">
            <label>Desconto PIS/COFINS: </label>
            <strong data-label="desconto-pis-cofins" id="eDescPisCofins">
              R$ {{mix.valor_desconto_pis_cofins}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.total_liquido_sem_promocao) > 0">
            <label>Total. líquido sem promoção: </label>
            <strong data-label="total-liquido-sem-promocao" id="eTotalLiquidoSemPromocao">
              R$ {{mix.total_liquido_sem_promocao}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.total_promocao) > 0">
            <label>Total promoção: </label>
            <strong data-label="total-promocao" id="eTotalPromocao">
              R$ {{mix.total_promocao}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.outras_despesas) > 0">
            <label>Outras despesas: </label>
            <strong data-label="outras-despesas" id="eOutrasDespesas">
              R$ {{mix.outras_despesas}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.tarifa_credito) > 0">
            <label>Tarifa de crédito: </label>
            <strong data-label="tarifda-credito" id="eTarifaCredito">
              R$ {{mix.tarifa_credito}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.total_frete) > 0">
            <label>Frete: </label>
            <strong data-label="total-frete" id="eFrete">
              R$ {{mix.total_frete}}
            </strong>
          </div>

          <div class="w3-row" v-if="parseFloat(mix.total_entradas) > 0">
            <label>Entradas: </label>
            <strong data-label="total-entradas" id="eTotalEntradas">
              R$ {{mix.total_entradas}}
            </strong>
          </div>

        </div>
        <h6 @click="mostrarTotais()" 
        v-if="mostrar_totais" 
        class="texto-vermelho w3-animate-zoom">&nbsp;
          <i class="fas fa-arrow-circle-up w3-animate-zoom seta-mais-itens"></i>
        </h6>
                    
      </div>
      <div class="w3-col l6 s12 m6">
        <h6 @click="mostrarItens()" 
        v-if="!mostrar_itens" 
        class="fundo-cabecalho ">&nbsp;
          <i class="fas fa-caret-right"></i>&nbsp;
          <a href="#">Itens</a>
        </h6>

        <h6 @click="mostrarItens()" 
        v-if="mostrar_itens" 
        class="fundo-cabecalho ">&nbsp;
          <i class="fas fa-sort-down"></i>&nbsp;
          <a href="#">Itens</a>
        </h6>
      </div>

      <div v-if="mostrar_itens">
        <div 
          style="padding-top: 3px; margin-top: 10px;" 
          :style="getStyleFundoItens(produto.mostrar_detalhes)"
          class="w3-show card-itens w3-border w3-animate-zoom" 
          v-for="(produto, index) in mix.itens_mix" :key="index"> 

          <div class="w3-col numero-pagina">
            <label>Item {{index + 1}}</label>
          </div>
                
          <div class="w3-col">
            <legenda>
              <span v-if="autorizado_visualizar_lucratividade_mix">mix: {{produto.perc_lucro_liquido.replace(' ','')}}%</span>
              <span v-if="!autorizado_visualizar_lucratividade_mix">Informações mix</span>
              <i slot="referencia" class="fa fa-circle bolinha w3-border" :style="getEstiloCor(produto.cor)"></i>
            </legenda>

            <strong class="texto-vermelho" @click="alternarMostrarDetalhes(index)">
              {{produto.produto_id}} - <span style="letter-spacing: .5px">{{produto.nome}}</span>
            </strong> 
          </div>

          <div @click="alternarMostrarDetalhes(index)"> 

            <div>
              <label>Preço venda:</label>
              <strong>R$ {{formatarValor(strPadraoToNumber(produto.preco_venda), 2)}}</strong>
              <label v-if="!produto.mostrar_detalhes" style="font-size:20px;"></label>
            </div>
                    
            <div v-if="produto.mostrar_detalhes">
              <label>Preço base: </label>
              <strong>R$ {{formatarValor(strPadraoToNumber(produto.preco_base), 2)}}</strong>
            </div>

            <div>
              <label>Total do item: </label>
                <strong>R$ {{produto.total_venda}}</strong>
            </div> 

            <div v-if="autorizado_visualizar_lucratividade_mix && produto.mostrar_detalhes">
              <label>Total custo compra: </label>
              <strong>R$ {{produto.total_custo_compra}}</strong>
            </div>

            <div v-if="autorizado_visualizar_lucratividade_mix && produto.mostrar_detalhes">
              <label>Custo compra: </label>
              <strong>R$ {{produto.custo_compra}}</strong>
            </div>

            <div v-if="autorizado_visualizar_lucratividade_mix && produto.mostrar_detalhes">
              <label>Total custo final: </label>
              <strong>R$ {{produto.total_custo_final}}</strong>
            </div>

            <div>
              <label>Quantidade: </label>
              <strong>{{produto.quantidade}}</strong>
            </div>

          </div>

          <div @click="alternarMostrarDetalhes(index)">

            <div v-if="parseFloat(produto.frete_nao_cobrado) > 0 && produto.mostrar_detalhes">
              <label>Frete não cobrado: </label>
              <strong>R$ {{produto.frete_nao_cobrado}}</strong>
            </div>

            <div
              v-if="autorizado_visualizar_lucratividade_mix && 
              parseFloat(produto.valor_frete_cif_embutido) > 0 &&
              produto.mostrar_detalhes">
              <label>Frete CIF embutido: </label>
              <strong>R$ {{produto.valor_frete_cif_embutido}}</strong>
            </div>

            <div v-if="parseFloat(produto.valor_juros_embutidos) > 0 && produto.mostrar_detalhes">
              <label>Val.juros embutido: </label>
              <strong>R$ {{produto.valor_juros_embutidos}}</strong>
            </div>

            <div v-if="parseFloat(produto.encargos) > 0 && produto.mostrar_detalhes">
              <label>Encargos: </label>
              <strong>R$ {{produto.encargos}}</strong>
            </div>

            <div v-if="parseFloat(produto.valor_comissao_profissional) > 0 && produto.mostrar_detalhes">
              <label>Comissão profissional: </label>
              <strong>R$ {{produto.valor_comissao_profissional}}</strong>
            </div>

            <div  v-if="parseFloat(produto.custo_difal) > 0 &&
              produto.mostrar_detalhes &&
              autorizado_visualizar_lucratividade_mix">
              
              <label>Custo DIFAL: </label>
              <strong>R$ {{produto.custo_difal}}</strong>
            </div>

            <div v-if="parseFloat(produto.protege) > 0 &&
              produto.mostrar_detalhes && 
              autorizado_visualizar_lucratividade_mix">
              
              <label>PROTEGE: </label>
              <strong>R$ {{produto.protege}}</strong>
            </div>

            <div v-if="parseFloat(produto.deducao_icms_produzir) > 0 && produto.mostrar_detalhes">
              <label>Dedução ICMS produzir: </label>
              <strong>R$ {{produto.deducao_icms_produzir}}</strong>
            </div>

            <div v-if="produto.mostrar_detalhes && autorizado_visualizar_lucratividade_mix">
              <label>Imp./Outros: </label>
              <strong><span>R$ {{produto.impostos.replace(' ','')}}</span></strong>
            </div>
            
            <div v-if="produto.mostrar_detalhes && autorizado_visualizar_lucratividade_mix">
              <label>Total imp./Outros: </label>
              <strong><span>R$ {{produto.total_impostos.replace(' ','')}}</span></strong>
            </div>

            <div v-if="produto.mostrar_detalhes && autorizado_visualizar_lucratividade_mix">
              <label>Acrescimo: </label>
              <strong><span>({{produto.perc_acrescimo.replace(' ','')}}%)</span></strong>
            </div>

            <div v-if="autorizado_visualizar_lucratividade_mix" >
              <label>Lucro bruto: </label>
              <strong>
                <span :class="getCorLucro(produto.lucro_bruto)">
                  R$ {{produto.lucro_bruto}} ({{produto.perc_lucro_bruto.replace(' ','')}}%)
                </span>
              </strong>
            </div>

            <div v-if="autorizado_visualizar_lucratividade_mix || autorizado_visualizar_lucro_liquido_mix">
              <label>Lucro líquido: </label>
              <strong> 
                <span :class="getCorLucro(produto.perc_lucro_liquido)">
                  R$ {{produto.lucro_liquido}} ({{produto.perc_lucro_liquido.replace(' ','')}}%)
                </span>
              </strong>
            </div>

            <div class="w3-col s12 w3-center" v-show="!produto.mostrar_detalhes">
              <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
            </div>

          </div>
        </div> 
      </div>               
      <footer class="w3-container conteudo-centralizado">
        <button 
          class="w3-btn w3-theme " 
          id="btn-ok-mix"
          style="margin-top: 10px; margin-bottom:10px" 
          @click="fechar()">
          <i class="fas fa-check-circle"></i> Ok
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import legenda from '@/components/Legendas'
  import ROrcamentoBuscarAutorizacoesMix from '@/components/Rest/ROrcamento/ROrcamentoBuscarAutorizacoesMix.js'

  export default {
    name: 'ModalMix',
    props: ['mix'],
    mixins: [formatarValorMixin],
    components: {
      legenda,
    },
    data() {
      return {
        api: process.env.API,
        autorizado_visualizar_mix: false,
        autorizado_visualizar_lucratividade_mix: false,
        autorizado_visualizar_lucro_liquido_mix: false,
        mostrar_items_custo: false,
        mostrar_items_totais: false,
        mostrar_items_apuracao_lucro: false,
        mostrar_custos: false,
        mostrar_totais: false,
        mostrar_lucro: false,
        mostrar_informacao_produto: false,
        contador: 0,
        mostrar_itens: true,
        visivel: false,
      }
    },
  
    async created() {
      this.contador = 0;
      this.buscarAutorizacoesMix();
    },

    methods: {
      async buscarAutorizacoesMix(){
        try {

          let retorno = await ROrcamentoBuscarAutorizacoesMix.buscarAutorizacoesMix(this.axios);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem)
          }  
          
          /* Autorização*/
          this.autorizado_visualizar_mix = retorno.dados.aut_verificar_mix_venda == 'S' ? true : false;
          this.autorizado_visualizar_lucratividade_mix = retorno.dados.aut_permitir_visualizar_lucratividade_mix == 'S' ? true : false;
          this.autorizado_visualizar_lucro_liquido_mix = retorno.dados.aut_permitir_visualizar_lucro_liquido_mix == 'S' ? true : false;

          if (!this.autorizado_visualizar_mix){
            Biblioteca.exclamar('Usuário não autorizado a verificar mix de venda!');
            this.fechar();
          }

          this.visivel = true;
        } catch (error) {
          Biblioteca.gerarLogNomeFuncao('ModalMix.vue -> buscarAutorizacoesMix');
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);
        }
      },

      fechar(){
        this.visivel = false;
        this.$emit('close');
      },

      dadosMixOrcamentoTela(mix){
        this.mix = mix;
      },

      mostrarItens() {
        this.mostrar_itens = !this.mostrar_itens;
      },

      mostrarLucro() {
        this.mostrar_lucro = !this.mostrar_lucro;
      },

      alternarMostrarDetalhes(index) {
        this.mix.itens_mix[index].mostrar_detalhes = !this.mix.itens_mix[index].mostrar_detalhes;
        this.$forceUpdate();
      },

      mostrarTotais() {
        this.mostrar_totais = !this.mostrar_totais;
      },

      mostrarCustos() {
        this.mostrar_custos = !this.mostrar_custos;
      },

      mostrarItemsCusto() {
        this.mostrar_items_custo = !this.mostrar_items_custo;
      },

      mostrarItemsTotais() {
        this.mostrar_items_totais = !this.mostrar_items_totais;
      },

      mostrarItemsApuracaoLucro() {
        this.mostrar_items_apuracao_lucro = !this.mostrar_items_apuracao_lucro;
      },

      getEstiloCor(estilo) {
        return 'color: ' + estilo;
      },

      getStyleFundoItens(ativado) {
        return ativado ? 'border: 1px solid #bfbfbf; box-shadow: #7a7a7a 1px 2px 5px 2px;' : 'background-color: white';
      },

      atualizar() {
        this.$parent.buscarComprasEmAberto();
      },

      getCorLucro: function(lucro) {
        let valor = parseFloat(lucro)
        if (valor > 0) {
          return "w3-text-green";
        } else {
          return "w3-text-theme";
        }
      },
    }
  }
</script>

<style scoped>
  .modal-container {
    animation: animatezoom 0.6s;
    margin: 20px;
    width: auto;
    height: auto;
    border-radius: 12px;
    max-height: 95%;
    overflow: auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 1 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
    
  .card-informacoes {
    margin-bottom: 10px;
    float: left;
    padding: 1px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
    border-radius: 10px;
    box-shadow: #ddd 0px 5px 3px 3px;
  }
    
  .card-itens {
    margin-bottom: 10px;
    border: 1px;
    float: left;
    padding: 7px;
    border-color: #9c9c9c !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
    border-radius: 10px;
    box-shadow: #ddd 0px 5px 3px 3px;
  }
    
  .numero-pagina {
    float: right !important;
    text-align: inherit;
    padding-left: calc( 100% - 50px);
    font-style: italic;
    color: grey;
  }
    
  .data {
    margin-left: calc(100% - 80px);
  }
    
  .fundo-cabecalho {
    background-color: #9c1d1c;
    color: white;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }
    
  .bolinha {
    border-radius: 100%;
  }
    
  .texto-verde {
    color: green;
  }
    
  .seta-mais-itens {
    width: auto;
    color: #9c1d1c;
    text-align: center;
    display: inline-block;
    position: absolute;
    font-size: 20px;
    z-index: 200000;
    -webkit-animation: move-seta 1.5s;
    /* Safari 4.0 - 8.0 */
    animation: move-seta 1.5s;
  }
  
  .seta-menos-itens {
    width: auto;
    color: white;
    margin-top: 1px;
    display: inline-block;
    position: absolute;
    font-size: 15px;
    z-index: 200000;
    -webkit-animation: move-seta 1.5s;
    /* Safari 4.0 - 8.0 */
    animation: move-seta 1.5s;
  }
    
  @-webkit-keyframes move-seta {
    0% {
      transform: rotate(90deg)
    }
    100% {}
  }
    
  @keyframes move-seta {
    0% {
      transform: rotate(90deg);
    }
    100% {}
  }
    
  .legenda {
    width: auto;
    background-color: #0077b5!important;
    color: #fff;
    text-align: center;
    padding: 2px;
    display: inline-block;
    border-radius: 3px;
    position: absolute;
    font-size: 14px;
    font-weight: normal;
    z-index: 200000;
    -moz-box-shadow: rgb(58, 58, 58) 0 0 1px 0;
    -webkit-box-shadow: rgb(58, 58, 58) 0 0 1px 0;
    box-shadow: rgb(58, 58, 58) 0 0 1px 0;
    margin-top: -25px;
  }
  .legenda::before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #0077b5 transparent transparent transparent;
  }
    
  .legenda {
    margin-bottom: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ModalMix.vue